import { IsOptional, ValidateNested } from "class-validator";
import { Type } from "class-transformer";

import { ShowRegistrationInfoDto } from "./show-registration-info.dto";
import { DogRegistrationInfoDto } from "./dog-registration-info.dto";
import { DogOwnerInfoDto } from "./dog-owner-info.dto";
import { DogCoownerInfoDto } from "../dog";

export class EventRegistrationUpdateDto {
  @IsOptional()
  @Type(() => ShowRegistrationInfoDto)
  show_registration?: ShowRegistrationInfoDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => DogRegistrationInfoDto)
  dog?: DogRegistrationInfoDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => DogOwnerInfoDto)
  owner?: DogOwnerInfoDto;

  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => DogCoownerInfoDto)
  coowners?: DogCoownerInfoDto[];
}
